import React, { useState, useEffect, useContext, useCallback } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Swal from "sweetalert2";
import { AuthContext, CompanyContext } from "../../utils/CompanyContext";
import TimeFrame from "../../customComponents/timeFrame";
import { CustomSelect } from "../../customComponents/select";
import { TikcerScroll } from "../partialScreens";
import {
  setOrganizationDetail,
  getDimWorkWeeksAllRequest,
  getAgentDashboardOrgProgramsTimeFrame,
  getAgentDashboardDataCoachingConfig,
  getAgentDashboardOrgProgramsBasedOnRecorddateAndType,
  getAgentDetails,
  getUserMetaData,
  getAgentCoachHistory,
  getActivityDashboard,
  getAgentGameTable,
  getAgentCurrentCommitments,
  getAgentBestPractices,
  getExecAgentDashboardMetrics,
  getdashboardconfigurationValues,
  latestcompletedrecord,
  getqudarantthreecardsExecAgent,
  agentdbRecognizationDetails,
  getMultiMonthScoreCardPermission,
  getAgentAIMLConfigurations,
  getAIMLMessages,
  getIntradayAgentDashboardTicker,
  getExecAgentDashboardMetricsReset,
  getAgentDetailsReset,
  getAgentCurrentCommitmentsReset,
  getAgentIncentiveRings,
} from "../../store/actions";
import { getAllUrlParams } from "../../utils/urlParams";
import { CompanyGUIDs } from "../../utils";

const TimeFrameBlock = (props) => {
  const dispatch = useDispatch();

  const [frameDataValue, setFrameData] = useState({});
  const [urlFrameData, setUrlFrameData] = useState(undefined);
  const [orgList, setOrgList] = useState([]);
  const [orgValue, setOrgValue] = useState();
  const [programValue, setProgramValue] = useState();
  const [programOption, setProgramOption] = useState([]);
  const {
    CGUID,
    Employeeid,
    LoginEmail,
    usertype,
    loginemptitle,
    DefaultOrganization,
  } = useContext(AuthContext);
  const { currentCompanyGuid } = useContext(CompanyContext);
  const defaultParam = {
    companyguid: currentCompanyGuid,
  };
  const {
    orgProgramsData,
    workWeeksAllList,
    activeOrganizationInfo,
    userMetaInfo,
    aimlConfigurationsInfo,
    intraDayInfo,
    agentDashboardTimeFrameInfo,
    agentDashboardBasedOnRecordDateTimeInfo,
  } = useSelector(
    ({
      get_agent_dashboard_org_programs: { data },
      get_dim_work_weeks_all: { data: workWeeksAllData },
      get_active_organization_detail: { data: activeOrganizationData },
      get_user_meta_data: { data: userMetaData },
      get_agent_aiml_configurations: { data: aimlConfigurationsData },
      get_intra_day_agent_dashboard_ticker: { data: intraDayData },
      get_agent_dashboard_org_programs_time_frame: {
        data: agentDashboardTimeFrameData,
      },
      get_agent_dashboard_org_programs_basedon_record_date_and_type: {
        data: agentDashboardBasedOnRecordDateTimeData,
      },
    }) => ({
      orgProgramsData: data,
      workWeeksAllList: workWeeksAllData,
      activeOrganizationInfo: activeOrganizationData || {},
      userMetaInfo: userMetaData || {},
      aimlConfigurationsInfo: aimlConfigurationsData || {},
      intraDayInfo: intraDayData || [],
      agentDashboardTimeFrameInfo: agentDashboardTimeFrameData,
      agentDashboardBasedOnRecordDateTimeInfo:
        agentDashboardBasedOnRecordDateTimeData,
    }),
    shallowEqual,
  );

  const agentDashboardDataCoachingConfig = useSelector(
    (state) => state.get_agent_dashboard_data_coaching_config?.data,
  );
  const saveSelectionInStore = (payload) =>
    dispatch(setOrganizationDetail(payload));

  useEffect(() => {
    if (!workWeeksAllList?.length) return;
    const { type, transdate } = getAllUrlParams();

    if (!type || !transdate) return;

    const matchedFrame = workWeeksAllList.find(
      (item) => item.transdate === transdate,
    );
    if (!matchedFrame) return;

    setUrlFrameData({
      frameData: matchedFrame,
      type: type,
    });
    setFrameData({
      recordtype: type,
      recorddate: transdate,
    });
    saveSelectionInStore({
      FrameData: matchedFrame,
      Type: type,
    });
  }, [workWeeksAllList]);

  const getDimWorkWeeksAllData = useCallback(
    (orgVal) =>
      dispatch(
        getDimWorkWeeksAllRequest({
          ...defaultParam,
          organization: orgVal,
        }),
      ),
    [dispatch],
  );
  const getAIMLConfigurations = useCallback(
    (orgVal) =>
      dispatch(
        getAgentAIMLConfigurations({
          ...defaultParam,
          organization: orgVal,
        }),
      ),
    [dispatch],
  );
  const handleOrgChange = (event) => {
    let orgVal = event.target.value;
    const selectedOrg = orgList.find(
      ({ organization }) => organization === orgVal,
    );
    setProgramOption(selectedOrg.primaryPrograms);
    setProgramValue(selectedOrg.primaryPrograms[0]);
    getDimWorkWeeksAllData(orgVal);
    getAIMLConfigurations(orgVal);
    setOrgValue(orgVal);
    saveSelectionInStore({
      ...defaultParam,
      Organization: orgVal,
      Program: selectedOrg.primaryPrograms?.[0],
    });
    dispatch(
      getIntradayAgentDashboardTicker({
        CompanyGuid: currentCompanyGuid,
        organization: orgVal,
        primaryprogram: selectedOrg.primaryPrograms?.[0],
        Employee_id: Employeeid,
      }),
    );
  };
  const refreshAgentDetails = useCallback(
    ({ recordtype, recorddate, primaryPrograms, organization }) => {
      const employeeid = Employeeid;
      const fetchActions = [
        getAgentDetails({
          ...defaultParam,
          organization: organization || orgValue,
          primaryprogram: primaryPrograms || programValue,
          employeeid,
          recordtype,
          recorddate,
        }),
        getUserMetaData({
          ...defaultParam,
          loginid: LoginEmail,
          varcharemployeeid: employeeid,
        }),
        getAgentCoachHistory({
          ...defaultParam,
          organization: organization || orgValue,
          employeeid,
          program: primaryPrograms || programValue,
          accessloginid: employeeid,
        }),
        getActivityDashboard({
          ...defaultParam,
          organization: organization || orgValue,
          employeeid,
          primaryprogram: primaryPrograms || programValue,
          dashboard: "L1",
        }),
        agentdbRecognizationDetails({
          ...defaultParam,
          organization: organization || orgValue,
          employeeid,
          program: primaryPrograms || programValue,
          accessloginid: employeeid,
        }),
        getAgentGameTable({
          ...defaultParam,
          organization: organization || orgValue,
          employeeid,
          program: primaryPrograms || programValue,
        }),
        getAgentCurrentCommitments({
          ...defaultParam,
          organization: organization || orgValue,
          employeeid,
          program: primaryPrograms || programValue,
        }),
        getqudarantthreecardsExecAgent({
          ...defaultParam,
          organization: organization || orgValue,
          employeenumber: employeeid,
          primaryprogram: primaryPrograms || programValue,
          recorddate: recorddate,
        }),
        ...(currentCompanyGuid === CompanyGUIDs["FIRST ADVANTAGE"]
          ? [
              getAgentIncentiveRings({
                ...defaultParam,
                organization: organization || orgValue,
                employeeid: employeeid,
                primaryprogram: primaryPrograms || programValue,
                recorddate: recorddate,
                recordtype: recordtype,
              }),
            ]
          : []),
        getAgentBestPractices({
          ...defaultParam,
          organization: organization || orgValue,
          program: primaryPrograms || programValue,
          employeeid,
        }),
        getdashboardconfigurationValues({
          ...defaultParam,
          organization: organization || orgValue,
          dashboard: "Agent Dashboard",
          configurationName: "",
        }),
        latestcompletedrecord({ ...defaultParam, organization: orgValue }),
        getMultiMonthScoreCardPermission({
          ...defaultParam,
          organization: organization || orgValue,
          employeenumber: employeeid,
        }),
        getExecAgentDashboardMetrics({
          ...defaultParam,
          organization: organization || orgValue,
          varemployee_loginid: employeeid,
          primaryprogram: primaryPrograms || programValue,
          userlogedinemail: LoginEmail,
          loggedintitle: loginemptitle || "TEAM LEADER",
          canenhance: userMetaInfo?.[0]?.performenchance || "N",
          usertype: usertype,
          timeperiod: recordtype,
          recorddate,
        }),
      ];
      fetchActions.forEach((action) => dispatch(action));
    },
    [dispatch, orgValue, programValue, Employeeid],
  );

  const getFrameData = ({ type, frameData }) => {
    dispatch(
      getAgentDashboardDataCoachingConfig({
        ...defaultParam,
        organization: orgValue,
      }),
    );
    dispatch(
      getAgentDashboardOrgProgramsTimeFrame({
        ...defaultParam,
        organization: orgValue,
        primaryprogram: programValue,
        loginid: Employeeid,
        recordtype: type,
        recorddate: frameData.transdate,
      }),
    );
    setFrameData({
      recordtype: type,
      recorddate: frameData.transdate,
    });
    // refreshAgentDetails({
    //   recordtype: type,
    //   recorddate: frameData.transdate,
    // });
    saveSelectionInStore({ FrameData: frameData, Type: type });
  };

  const onApplyFrameData = ({ type, frameData }) => {
    dispatch(
      getAgentDashboardOrgProgramsBasedOnRecorddateAndType({
        ...defaultParam,
        organization: orgValue,
        primaryprogram: programValue,
        loginid: Employeeid,
        employeeid: Employeeid,
        recordtype: type,
        recorddate: frameData.transdate,
      }),
    );

    dispatch(
      getAgentDashboardDataCoachingConfig({
        ...defaultParam,
        organization: orgValue,
      }),
    );
    dispatch(
      getAgentDashboardOrgProgramsTimeFrame({
        ...defaultParam,
        organization: orgValue,
        primaryprogram: programValue,
        loginid: Employeeid,
        recordtype: type,
        recorddate: frameData.transdate,
      }),
    );
    setFrameData({
      recordtype: type,
      recorddate: frameData.transdate,
    });

    saveSelectionInStore({ FrameData: frameData, Type: type });
  };

  const onProgramChange = (event) => {
    let proVal = event.target.value;
    setProgramValue(proVal);
    saveSelectionInStore({
      Program: proVal,
    });
    refreshPartial(proVal);
  };

  const refreshPartial = useCallback(
    (programValue) => {
      let employeeid = Employeeid;
      let recorddate = activeOrganizationInfo?.FrameData.transdate || {};
      let recordtype = activeOrganizationInfo?.Type || {};
      // dispatch(
      //   getAgentDashboardOrgProgramsTimeFrame({
      //     ...defaultParam,
      //     organization: orgValue,
      //     primaryprogram: programValue,
      //     loginid: employeeid,
      //     recordtype: recordtype,
      //     recorddate: recorddate,
      //   })
      // );
      dispatch(
        getAgentDetails({
          ...defaultParam,
          organization: orgValue,
          primaryprogram: programValue,
          employeeid,
          recordtype,
          recorddate,
        }),
      );
      dispatch(
        getUserMetaData({
          ...defaultParam,
          loginid: LoginEmail,
          varcharemployeeid: employeeid,
        }),
      );
      dispatch(
        getAgentCoachHistory({
          ...defaultParam,
          organization: orgValue,
          employeeid: employeeid,
          program: programValue,
          accessloginid: employeeid,
        }),
      );
      dispatch(
        getActivityDashboard({
          ...defaultParam,
          organization: orgValue,
          employeeid: employeeid,
          primaryprogram: programValue,
          dashboard: "L1",
        }),
      );
      dispatch(
        getIntradayAgentDashboardTicker({
          CompanyGuid: currentCompanyGuid,
          organization: orgValue,
          primaryprogram: programValue,
          Employee_id: employeeid,
        }),
      );
      dispatch(
        getqudarantthreecardsExecAgent({
          CompanyGuid: currentCompanyGuid,
          organization: orgValue,
          primaryprogram: programValue,
          employeenumber: employeeid,
          recorddate: recorddate,
        }),
      );
      // this getAgentIncentiveRings is only for First Advantage
      currentCompanyGuid === CompanyGUIDs["FIRST ADVANTAGE"] &&
        dispatch(
          getAgentIncentiveRings({
            companyguid: currentCompanyGuid,
            organization: orgValue,
            primaryprogram: programValue,
            employeeid: employeeid,
            recordtype: recordtype,
            recorddate: recorddate,
          }),
        );
      dispatch(
        getAgentCurrentCommitments({
          CompanyGuid: currentCompanyGuid,
          organization: orgValue,
          program: programValue,
          employeeid: employeeid,
        }),
      );
      dispatch(
        agentdbRecognizationDetails({
          CompanyGuid: currentCompanyGuid,
          organization: orgValue,
          program: programValue,
          employeeid: employeeid,
          accessloginid: employeeid,
        }),
      );
      dispatch(
        getAgentGameTable({
          CompanyGuid: currentCompanyGuid,
          organization: orgValue,
          program: programValue,
          employeeid: employeeid,
        }),
      );
      dispatch(
        getAgentBestPractices({
          CompanyGuid: currentCompanyGuid,
          organization: orgValue,
          program: programValue,
          employeeid: employeeid,
        }),
      );
      dispatch(
        getExecAgentDashboardMetrics({
          ...defaultParam,
          organization: orgValue,
          varemployee_loginid: employeeid,
          primaryprogram: programValue,
          userlogedinemail: LoginEmail,
          loggedintitle: loginemptitle || "TEAM LEADER",
          canenhance: userMetaInfo?.[0]?.performenchance || "N",
          usertype: usertype,
          timeperiod: recordtype,
          recorddate: recorddate,
        }),
      );
    },
    [dispatch, orgValue, activeOrganizationInfo, Employeeid],
  );

  useEffect(() => {
    if (orgProgramsData && orgProgramsData[0]) {
      setOrgList(orgProgramsData);

      const activeOrg = orgProgramsData.find(
        (or) => DefaultOrganization === or.organization,
      );
      const { organization, primaryPrograms } = activeOrg
        ? activeOrg
        : orgProgramsData[0];
      setOrgValue(organization);
      // setOrgValue(DefaultOrganization);
      setProgramOption(primaryPrograms);
      setProgramValue(primaryPrograms[0]);
      getDimWorkWeeksAllData(organization);
      getAIMLConfigurations(organization);
      dispatch(
        getIntradayAgentDashboardTicker({
          CompanyGuid: currentCompanyGuid,
          organization: organization,
          primaryprogram: primaryPrograms[0],
          Employee_id: Employeeid,
        }),
      );
    }
  }, [orgProgramsData, getDimWorkWeeksAllData]);
  useEffect(() => {
    if (userMetaInfo?.length > 0) {
      saveSelectionInStore({
        titleroletype: userMetaInfo[0]?.titleroletype,
        performenchance: userMetaInfo[0]?.performenchance,
      });
    }
  }, [userMetaInfo]);
  useEffect(() => {
    if (
      aimlConfigurationsInfo?.[0]?.configurationName == "GENAIMESSAGING" &&
      aimlConfigurationsInfo?.[0]?.configurationValue == "Y"
    ) {
      dispatch(
        getAIMLMessages({
          ...defaultParam,
          organization: orgValue,
          program: programValue,
          employeeid: Employeeid,
        }),
      );
    }
  }, [aimlConfigurationsInfo]);
  useEffect(() => {
    if (agentDashboardTimeFrameInfo?.length > 0) {
      const { primaryPrograms, organization } = agentDashboardTimeFrameInfo[0];
      if (programValue != primaryPrograms[0]) {
        setProgramOption(primaryPrograms);
        setProgramValue(primaryPrograms[0]);
      }
      refreshAgentDetails({
        ...frameDataValue,
        primaryPrograms: primaryPrograms[0],
        organization: organization,
      });
    }
    if (agentDashboardTimeFrameInfo?.length == 0) {
      // reset metric related api data
      dispatch(getExecAgentDashboardMetricsReset({}));
      dispatch(getAgentDetailsReset({}));
      dispatch(getAgentCurrentCommitmentsReset({}));
      if (agentDashboardDataCoachingConfig == "N") {
        Swal.fire({
          text: "There is no data for you for this timeframe. Please select a different timeframe.",
        });
      }

      dispatch(
        getAgentDashboardOrgProgramsBasedOnRecorddateAndType({
          ...defaultParam,
          organization: orgValue,
          primaryprogram: programValue,
          loginid: Employeeid,
          employeeid: Employeeid,
          recordtype: frameDataValue.recordtype,
          recorddate: frameDataValue.recorddate,
        }),
      );
    }
  }, [agentDashboardTimeFrameInfo]);

  useEffect(() => {
    if (agentDashboardBasedOnRecordDateTimeInfo?.length > 0) {
      setOrgList(agentDashboardBasedOnRecordDateTimeInfo);

      const { primaryPrograms, organization } =
        agentDashboardBasedOnRecordDateTimeInfo[0];
      setOrgValue(organization);
      setProgramOption(primaryPrograms);
      setProgramValue(primaryPrograms[0]);
      saveSelectionInStore({
        ...defaultParam,
        Organization: organization,
        Program: primaryPrograms[0],
      });
      refreshAgentDetails({
        ...frameDataValue,
        primaryPrograms: primaryPrograms[0],
        organization: organization,
      });
    }
  }, [agentDashboardBasedOnRecordDateTimeInfo]);

  return (
    <div className="org_prog_header">
      <div className="container-fluid">
        <div className="row">
          <div className="d-flex flex-start align-start">
            <div className="w-40">
              <div className="org_block">
                <div className="form-group w-32">
                  <label htmlFor="organization">Organization</label>
                  <select
                    className="form-select"
                    id="organization"
                    onChange={handleOrgChange}
                    value={orgValue}
                  >
                    {orgList?.map(({ organization }, optIndex) => {
                      return (
                        <option
                          key={`${organization}${optIndex}`}
                          value={organization}
                        >
                          {organization}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <CustomSelect
                  id="primaryprogram"
                  label="Program"
                  options={programOption}
                  value={programValue}
                  onChange={onProgramChange}
                />

                <div className="form-group w-32">
                  <label>Time Frame</label>
                  <TimeFrame
                    workWeeksAllList={workWeeksAllList}
                    getFrameData={getFrameData}
                    onApplyFrameData={onApplyFrameData}
                    // currentFrameData={{
                    //   frameData: urlFrameData?.frameData,
                    //   type: urlFrameData?.type,
                    // }}
                    {...(urlFrameData && { currentFrameData: urlFrameData })}
                  />
                </div>
              </div>
            </div>
            <div className="w-60">
              {intraDayInfo?.length > 0 && (
                <TikcerScroll intraDayInfo={intraDayInfo} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeFrameBlock;
